import React from 'react';
import { Tag } from 'components/Tag';
import classnames from 'classnames';
import './ApprovalOddsTag.scss';

const approvalOddsList = {
  VERY_GOOD: 'Very Good',
  GOOD: 'Good',
  FAIR: 'Fair',
  POOR: 'Poor',
  NA: 'N/A',
};

/**
 *
 * @example ./Readme.md
 */
const ApprovalOddsTag = ({ approvalOdds, className = '', datatestid }) => {
  if (
    typeof approvalOdds !== 'string' ||
    typeof approvalOddsList[approvalOdds] !== 'string'
  ) {
    return '';
  }

  const approvalOddsClass = approvalOdds.toLowerCase();

  return (
    <Tag
      datatestid={datatestid}
      backgroundClass={classnames('approvalOdds', 'bold', approvalOddsClass, className)}
    >
      <div className="nAoTitle">{approvalOddsList[approvalOdds]}</div>
      <div className="nAoBlock">
        <div className="nAoBlocksub sub01"></div>
        <div className="nAoBlocksub sub02"></div>
        <div className="nAoBlocksub sub03"></div>
        <div className="nAoBlocksub sub04"></div>
        <div className="nAoBlocksub sub05"></div>
      </div>
    </Tag>
  );
};

export default ApprovalOddsTag;
